// extracted by mini-css-extract-plugin
module.exports = {"content":"create_disclaimer__content___3eH_1 _type__vx_text-5_lighter___2ilC-"};